import { GROUP_PERMISSIONS } from "./default_perms"

export const userStatusOptions = [
    { value: true, label: 'Hoạt động' },
    { value: false, label: 'Đang khoá' },
]

export const packageTypeOptions = [
    { value: 'EXPIRE_DAY', label: 'Hết hạn theo số ngày' },
    { value: 'EXPIRE_END_MONTH', label: 'Hết hạn vào ngày cuối tháng' },
    { value: 'EXPIRE_MONTH', label: 'Hết hạn vào ngày đó của tháng sau' },
]

export const partnerPackageTypeOptions = [
    { value: '3G', label: 'API gói' },
    { value: 'ADDON', label: 'Data Sponsor' },
    { value: 'CONNECTION', label: 'Đấu mới' },
    { value: 'EXTENSION', label: 'Gia hạn' },
]

export const packageStatusOptions = [
    { value: '1', label: 'Hoạt động' },
    { value: '2', label: 'Đang khoá' },
]

export const simPassportStatusOptions = [
    { value: 'COMPLETED', label: 'Hoàn thành' },
    { value: 'CANCELLED', label: 'Đã huỷ bỏ' },
    { value: 'PENDING', label: 'Chờ xác nhận' },
]

export const orderStatusOptions = [
    { value: 'COMPLETED', label: 'Hoàn thành' },
    { value: 'CANCELLED', label: 'Đã huỷ bỏ' },
    { value: 'CREATED', label: 'Đã tạo' },
    { value: 'PROCESSING', label: 'Đang xử lý' },
    { value: 'PENDING', label: 'Đang nạp excel' },
]

export const mbhStatusOptions = [
    { value: 'SUCCESS', label: 'Thành công' },
    { value: 'FAIL', label: 'Thất bại' },
    { value: 'ERROR', label: 'Lỗi' },
    { value: 'CREATED', label: 'Đã tạo' },
    { value: 'PROCESSING', label: 'Đang xử lý' },
    { value: 'TIMEOUT', label: 'Chưa rõ kết quả' },
]

export const invoiceStatusOptions = [
    { value: 'SUCCESS', label: 'Đã xuất' },
    { value: 'FAIL', label: 'Thất bại' },
    { value: 'ERROR', label: 'Lỗi' },
    { value: 'CREATED', label: 'Nháp' },
    { value: 'PROCESSING', label: 'Đang xử lý' },
]

export const transactionConnectionTypeOptions = [
    { value: 'CONNECTION', label: 'Đấu mới' },
    { value: 'EXTENSION', label: 'Gia hạn' },
]

export const simTypeOptions = [
    { value: 'WAREHOUSE', label: 'Sim nhập' },
    { value: 'INVENTORY', label: 'Sim xuất' },
]

export const transactionConnectionDiscountsOptions = [
    { value: '1,2', label: 'Gia hạn lần 2' },
    { value: '3,4', label: 'Đấu mới 12 tháng' },
]

export const priceTopupOptions = [
    { value: 5000, label: '5,000 đ' },
    { value: 100000, label: '100,000 đ' },
    { value: 480000, label: '480,000 đ' },
    { value: 500000, label: '500,000 đ' },
    { value: 750000, label: '750,000 đ' },
    { value: 960000, label: '960,000 đ' },
    { value: 1500000, label: '1,500,000 đ' },
]

export const packageTkgOptions = [
    { value: 'M2M200T', label: 'M2M200T - 3G - 200,000 đ/30 ngày' },
    { value: 'M2M70T', label: 'M2M70T - 3G - 70,000 đ/30 ngày' },
    { value: 'M2M300T', label: 'M2M300T - 3G - 300,000 đ/30 ngày' },
    { value: 'M2M50T', label: 'M2M50T - 3G - 50,000 đ/30 ngày' },
    { value: 'M2M250T', label: 'M2M250T - 3G - 250,000 đ/30 ngày' },
    { value: '6M128', label: '6M128 - 3G - 30,000 đ/180 ngày' },
    { value: 'M2M120T', label: 'M2M120T - 3G - 120,000 đ/30 ngày' },
    { value: '12M128', label: '12M128 - 3G - 60,000 đ/360 ngày' },
    { value: 'M128', label: 'M128 - 3G - 5,000 đ/30 ngày' },
]

export const typeCustomerOptions = [
    { value: 'CMND/CCCD', label: 'CMND/CCCD' },
    { value: 'Passport', label: 'Passport' },
]

export const typeNoteCustomerOptions = [
    { value: 'AGENCY', label: 'Đại lý' },
    { value: 'NOT_OWNER', label: 'Không phải chủ xe' },
    { value: 'CALL_LATER', label: 'Khách gọi lại sau' },
    { value: 'NO_ANSWER', label: 'Không nghe máy' },
    { value: 'NO_NEED', label: 'Không có nhu cầu' },
    { value: 'BOUGHT_NEW', label: 'Đã mua SIM mới' },
    { value: 'OTHER_REASONS', label: 'Khác' },
]

export const partnerHistoryOptions = [
    { value: 'CALLING', label: 'Cuộc gọi' },
    { value: 'GIFTING', label: 'Quà tặng' },
    { value: 'MEETING', label: 'Cuộc họp' },
]

export const partnerConnectionCommentOptions = [
    { value: 'CONNECTION-RECORD', label: 'Đấu nối' },
    { value: 'CONNECTION-PROFIT', label: 'Lợi nhuận' },
    { value: 'CONNECTION-PERIOD', label: 'Tỷ lệ gói' },
    { value: 'CONNECTION-SUMMARY', label: 'Tổng kết' },
    { value: 'CONNECTION-OTHER', label: 'Mặc định' },
]

export const partnerExtensionCommentOptions = [
    { value: 'EXTENSION-RECORD', label: 'Đấu nối' },
    { value: 'EXTENSION-PROFIT', label: 'Lợi nhuận' },
    { value: 'EXTENSION-PERIOD', label: 'Tỷ lệ gói' },
    { value: 'EXTENSION-SUMMARY', label: 'Tổng kết' },
    { value: 'EXTENSION-OTHER', label: 'Mặc định' },
]

export const partnerInfoOptions = [
    { value: 'PHONE', label: 'Số điện thoại' },
    { value: 'EMAIL', label: 'Email' },
    { value: 'DIRECTOR', label: 'Đại diện' },
    { value: 'ADDRESS', label: 'Địa chỉ' },
]

export const versionStatusOptions = [
    { value: 'NONE', label: 'Bình thường' },
    { value: 'OPTIONAL', label: 'Tuỳ chọn' },
    { value: 'REQUIREMENT', label: 'Yêu cầu cập nhật' },
    { value: 'MAINTAINED', label: 'Đang bảo trì' },
]

export const versionEnvOptions = [
    { value: 'PRODUCTION', label: 'PRODUCTION' },
    { value: 'DEVELOPMENT', label: 'DEVELOPMENT' },
]

export const permissionOptions = [
    // Show Content
    {
        label: 'Hiển thị tab gói cước',
        value: 'GET::/api/otek-dashboard/packages/see-package-tab',
        group: GROUP_PERMISSIONS.show_content,
        name: 'Nhóm quyền hiển thị nội dung',
    },
    {
        label: 'Cập nhật số điện thoại sim',
        value: 'PUT::/api/otek-dashboard/transaction-connection/update-phone-sim',
        group: GROUP_PERMISSIONS.show_content,
        name: 'Nhóm quyền hiển thị nội dung',
    },
    {
        label: 'Chọn ngày đấu nối',
        value: 'GET::/api/otek-dashboard/transaction-connection/select-date-connect',
        group: GROUP_PERMISSIONS.show_content,
        name: 'Nhóm quyền hiển thị nội dung',
    },

    // Company
    {
        label: 'Truy vấn danh sách công ty',
        value: 'GET::/api/otek-dashboard/companies',
        group: GROUP_PERMISSIONS.companies,
        name: 'Nhóm quyền quản lý công ty',
    },
    {
        label: 'Thêm công ty mới',
        value: 'POST::/api/otek-dashboard/companies',
        group: GROUP_PERMISSIONS.companies,
        name: 'Nhóm quyền quản lý công ty',
    },
    {
        label: 'Cập nhật thông tin công ty',
        value: 'PATCH::/api/otek-dashboard/companies',
        group: GROUP_PERMISSIONS.companies,
        name: 'Nhóm quyền quản lý công ty',
    },
    {
        label: 'Xoá công ty',
        value: 'DELETE::/api/otek-dashboard/companies',
        group: GROUP_PERMISSIONS.companies,
        name: 'Nhóm quyền quản lý công ty',
    },
    {
        label: 'Truy vấn danh sách thông tin liên hệ',
        value: 'GET::/api/otek-dashboard/companies/get-list-metadata',
        group: GROUP_PERMISSIONS.companies,
        name: 'Nhóm quyền quản lý công ty',
    },
    {
        label: 'Thêm danh sách thông tin liên hệ',
        value: 'POST::/api/otek-dashboard/companies/add-list-metadata',
        group: GROUP_PERMISSIONS.companies,
        name: 'Nhóm quyền quản lý công ty',
    },
    {
        label: 'Cập nhật danh sách thông tin liên hệ',
        value: 'PUT::/api/otek-dashboard/companies/update-list-metadata',
        group: GROUP_PERMISSIONS.companies,
        name: 'Nhóm quyền quản lý công ty',
    },
    {
        label: 'Truy vấn danh sách lịch sử tương tác',
        value: 'GET::/api/otek-dashboard/companies/get-list-feedback-history',
        group: GROUP_PERMISSIONS.companies,
        name: 'Nhóm quyền quản lý công ty',
    },
    {
        label: 'Thêm danh sách lịch sử tương tác',
        value: 'POST::/api/otek-dashboard/companies/add-list-feedback-history',
        group: GROUP_PERMISSIONS.companies,
        name: 'Nhóm quyền quản lý công ty',
    },
    {
        label: 'Cập nhật danh sách lịch sử tương tác',
        value: 'PUT::/api/otek-dashboard/companies/update-list-feedback-history',
        group: GROUP_PERMISSIONS.companies,
        name: 'Nhóm quyền quản lý công ty',
    },
    {
        label: 'Truy vấn danh sách lịch sử đánh giá',
        value: 'GET::/api/otek-dashboard/companies/get-list-feedback-comment',
        group: GROUP_PERMISSIONS.companies,
        name: 'Nhóm quyền quản lý công ty',
    },
    {
        label: 'Thêm danh sách lịch sử đánh giá',
        value: 'POST::/api/otek-dashboard/companies/add-list-feedback-comment',
        group: GROUP_PERMISSIONS.companies,
        name: 'Nhóm quyền quản lý công ty',
    },
    {
        label: 'Cập nhật danh sách lịch sử đánh giá',
        value: 'PUT::/api/otek-dashboard/companies/update-list-feedback-comment',
        group: GROUP_PERMISSIONS.companies,
        name: 'Nhóm quyền quản lý công ty',
    },
    {
        label: 'Truy vấn danh sách cấu hình thông báo',
        value: 'GET::/api/otek-dashboard/companies/get-list-company-notify-config',
        group: GROUP_PERMISSIONS.companies,
        name: 'Nhóm quyền quản lý công ty',
    },
    {
        label: 'Truy vấn cấu hình thông báo',
        value: 'GET::/api/otek-dashboard/companies/get-company-notify-config',
        group: GROUP_PERMISSIONS.companies,
        name: 'Nhóm quyền quản lý công ty',
    },
    {
        label: 'Thêm cấu hình thông báo',
        value: 'POST::/api/otek-dashboard/companies/add-company-notify-config',
        group: GROUP_PERMISSIONS.companies,
        name: 'Nhóm quyền quản lý công ty',
    },
    {
        label: 'Cập nhật cấu hình thông báo',
        value: 'PUT::/api/otek-dashboard/companies/update-company-notify-config',
        group: GROUP_PERMISSIONS.companies,
        name: 'Nhóm quyền quản lý công ty',
    },

    // Package
    {
        label: 'Truy vấn danh sách gói cước',
        value: 'GET::/api/otek-dashboard/packages',
        group: GROUP_PERMISSIONS.packages,
        name: 'Nhóm quyền quản lý gói cước',
    },
    {
        label: 'Thêm các gói cước mới',
        value: 'POST::/api/otek-dashboard/packages/add-list-packages',
        group: GROUP_PERMISSIONS.packages,
        name: 'Nhóm quyền quản lý gói cước',
    },
    {
        label: 'Xoá gói cước',
        value: 'DELETE::/api/otek-dashboard/packages',
        group: GROUP_PERMISSIONS.packages,
        name: 'Nhóm quyền quản lý gói cước',
    },
    {
        label: 'Truy vấn danh sách gói cước đối tác',
        value: 'GET::/api/otek-dashboard/partner-packages',
        group: GROUP_PERMISSIONS.packages,
        name: 'Nhóm quyền quản lý gói cước',
    },
    {
        label: 'Thêm các gói cước đối tác mới',
        value: 'POST::/api/otek-dashboard/partner-packages/add-list-partner-packages',
        group: GROUP_PERMISSIONS.packages,
        name: 'Nhóm quyền quản lý gói cước',
    },
    {
        label: 'Xoá gói cước đối tác',
        value: 'DELETE::/api/otek-dashboard/partner-packages',
        group: GROUP_PERMISSIONS.packages,
        name: 'Nhóm quyền quản lý gói cước',
    },
    {
        label: 'Cập nhật gói cước đối tác',
        value: 'PATCH::/api/otek-dashboard/partner-packages',
        group: GROUP_PERMISSIONS.packages,
        name: 'Nhóm quyền quản lý gói cước',
    },
    {
        label: 'Truy vấn danh sách gói cước API gói',
        value: 'GET::/api/otek-dashboard/partner-packages/get-list-packages-tkg-dashboard',
        group: GROUP_PERMISSIONS.packages,
        name: 'Nhóm quyền quản lý gói cước',
    },
    {
        label: 'Truy vấn danh sách gói cước data sponsor',
        value: 'GET::/api/otek-dashboard/partner-packages/get-list-packages-sponsor',
        group: GROUP_PERMISSIONS.packages,
        name: 'Nhóm quyền quản lý gói cước',
    },
    {
        label: 'Truy vấn danh sách gói cước đấu nối',
        value: 'GET::/api/otek-dashboard/partner-packages/get-list-packages-connection',
        group: GROUP_PERMISSIONS.packages,
        name: 'Nhóm quyền quản lý gói cước',
    },
    {
        label: 'Truy vấn danh sách khuyến mãi',
        value: 'GET::/api/otek-dashboard/rule-base/get-list-package-discount',
        group: GROUP_PERMISSIONS.packages,
        name: 'Nhóm quyền quản lý gói cước',
    },
    {
        label: 'Thêm danh sách khuyến mãi',
        value: 'POST::/api/otek-dashboard/rule-base/add-list-package-discount',
        group: GROUP_PERMISSIONS.packages,
        name: 'Nhóm quyền quản lý gói cước',
    },
    {
        label: 'Cập nhật danh sách khuyến mãi',
        value: 'PATCH::/api/otek-dashboard/rule-base/update-list-package-discount',
        group: GROUP_PERMISSIONS.packages,
        name: 'Nhóm quyền quản lý gói cước',
    },
    {
        label: 'Xoá danh sách khuyến mãi',
        value: 'DELETE::/api/otek-dashboard/rule-base/delete-list-package-discount',
        group: GROUP_PERMISSIONS.packages,
        name: 'Nhóm quyền quản lý gói cước',
    },
    {
        label: 'Truy vấn danh sách điều kiện',
        value: 'GET::/api/otek-dashboard/rule-base/get-list-condition-rule',
        group: GROUP_PERMISSIONS.packages,
        name: 'Nhóm quyền quản lý gói cước',
    },
    {
        label: 'Thêm danh sách điều kiện',
        value: 'POST::/api/otek-dashboard/rule-base/add-list-condition-rule',
        group: GROUP_PERMISSIONS.packages,
        name: 'Nhóm quyền quản lý gói cước',
    },
    {
        label: 'Cập nhật danh sách điều kiện',
        value: 'PATCH::/api/otek-dashboard/rule-base/update-list-condition-rule',
        group: GROUP_PERMISSIONS.packages,
        name: 'Nhóm quyền quản lý gói cước',
    },
    {
        label: 'Xoá danh sách điều kiện',
        value: 'DELETE::/api/otek-dashboard/rule-base/delete-list-condition-rule',
        group: GROUP_PERMISSIONS.packages,
        name: 'Nhóm quyền quản lý gói cước',
    },

    // Telegram
    {
        label: 'Truy vấn danh sách telegram',
        value: 'GET::/api/otek-dashboard/telegrams',
        group: GROUP_PERMISSIONS.telegrams,
        name: 'Nhóm quyền quản lý telegram',
    },
    {
        label: 'Thêm telegram mới',
        value: 'POST::/api/otek-dashboard/telegrams',
        group: GROUP_PERMISSIONS.telegrams,
        name: 'Nhóm quyền quản lý telegram',
    },
    {
        label: 'Cập nhật thông tin telegram',
        value: 'PATCH::/api/otek-dashboard/telegrams',
        group: GROUP_PERMISSIONS.telegrams,
        name: 'Nhóm quyền quản lý telegram',
    },
    {
        label: 'Xoá telegram',
        value: 'DELETE::/api/otek-dashboard/telegrams',
        group: GROUP_PERMISSIONS.telegrams,
        name: 'Nhóm quyền quản lý telegram',
    },

    // Transaction
    {
        label: 'Truy vấn danh sách giao dịch',
        value: 'GET::/api/otek-dashboard/transactions',
        group: GROUP_PERMISSIONS.transactions,
        name: 'Nhóm quyền quản lý giao dịch',
    },
    {
        label: 'Gia hạn giao dịch',
        value: 'PATCH::/api/otek-dashboard/transactions',
        group: GROUP_PERMISSIONS.transactions,
        name: 'Nhóm quyền quản lý giao dịch',
    },
    {
        label: 'Thêm giao dịch mới',
        value: 'POST::/api/otek-dashboard/transactions',
        group: GROUP_PERMISSIONS.transactions,
        name: 'Nhóm quyền quản lý giao dịch',
    },
    {
        label: 'Đấu nối giao dịch',
        value: 'POST::/api/otek-dashboard/transactions/connect',
        group: GROUP_PERMISSIONS.transactions,
        name: 'Nhóm quyền quản lý giao dịch',
    },

    // User
    {
        label: 'Truy vấn danh sách quản trị viên',
        value: 'GET::/api/otek-dashboard/users',
        group: GROUP_PERMISSIONS.users,
        name: 'Nhóm quyền quản lý quản trị viên',
    },
    {
        label: 'Thêm quản trị viên mới',
        value: 'POST::/api/otek-dashboard/users',
        group: GROUP_PERMISSIONS.users,
        name: 'Nhóm quyền quản lý quản trị viên',
    },
    {
        label: 'Cập nhật thông tin quản trị viên',
        value: 'PATCH::/api/otek-dashboard/users',
        group: GROUP_PERMISSIONS.users,
        name: 'Nhóm quyền quản lý quản trị viên',
    },
    {
        label: 'Xoá quản trị viên',
        value: 'DELETE::/api/otek-dashboard/users',
        group: GROUP_PERMISSIONS.users,
        name: 'Nhóm quyền quản lý quản trị viên',
    },

    // Role
    {
        label: 'Truy vấn danh sách quyền',
        value: 'GET::/api/otek-dashboard/base-permissions',
        group: GROUP_PERMISSIONS.roles,
        name: 'Nhóm quyền quản lý phân quyền',
    },
    {
        label: 'Reload danh sách quyền',
        value: 'POST::/api/otek-dashboard/base-permissions/reload-policy',
        group: GROUP_PERMISSIONS.roles,
        name: 'Nhóm quyền quản lý phân quyền',
    },
    {
        label: 'Truy vấn danh sách phân quyền',
        value: 'GET::/api/otek-dashboard/roles',
        group: GROUP_PERMISSIONS.roles,
        name: 'Nhóm quyền quản lý phân quyền',
    },
    {
        label: 'Thêm phân quyền mới',
        value: 'POST::/api/otek-dashboard/roles',
        group: GROUP_PERMISSIONS.roles,
        name: 'Nhóm quyền quản lý phân quyền',
    },
    {
        label: 'Cập nhật thông tin phân quyền',
        value: 'PATCH::/api/otek-dashboard/roles',
        group: GROUP_PERMISSIONS.roles,
        name: 'Nhóm quyền quản lý phân quyền',
    },
    {
        label: 'Xoá phân quyền',
        value: 'DELETE::/api/otek-dashboard/roles',
        group: GROUP_PERMISSIONS.roles,
        name: 'Nhóm quyền quản lý phân quyền',
    },

    // Sim Passports
    {
        label: 'Truy vấn danh sách sim passports',
        value: 'GET::/api/otek-dashboard/sim-passports',
        group: GROUP_PERMISSIONS.sim_passports,
        name: 'Nhóm quyền quản lý sim passports',
    },
    {
        label: 'Cập nhật thông tin sim passports',
        value: 'PATCH::/api/otek-dashboard/sim-passports',
        group: GROUP_PERMISSIONS.sim_passports,
        name: 'Nhóm quyền quản lý sim passports',
    },

    // Mbh Topups
    {
        label: 'Kiểm tra số dư',
        value: 'GET::/api/otek-dashboard/mbh-topups/check-balance-topup',
        group: GROUP_PERMISSIONS.mbh_topups,
        name: 'Nhóm quyền quản lý nạp tiền',
    },
    {
        label: 'Truy vấn danh sách đơn hàng',
        value: 'GET::/api/otek-dashboard/mbh-topups/get-list-order-topups',
        group: GROUP_PERMISSIONS.mbh_topups,
        name: 'Nhóm quyền quản lý nạp tiền',
    },
    {
        label: 'Truy vấn danh sách giao dịch bằng mã đơn hàng',
        value: 'GET::/api/otek-dashboard/mbh-topups/get-list-transaction-topups-by-order-id',
        group: GROUP_PERMISSIONS.mbh_topups,
        name: 'Nhóm quyền quản lý nạp tiền',
    },
    {
        label: 'Kiểm tra giao dịch trên hệ thống',
        value: 'GET::/api/otek-dashboard/mbh-topups/check-transaction-topup-on-resource',
        group: GROUP_PERMISSIONS.mbh_topups,
        name: 'Nhóm quyền quản lý nạp tiền',
    },
    {
        label: 'Kiểm tra giao dịch bên đối tác',
        value: 'GET::/api/otek-dashboard/mbh-topups/check-transaction-topup-on-adapter',
        group: GROUP_PERMISSIONS.mbh_topups,
        name: 'Nhóm quyền quản lý nạp tiền',
    },
    {
        label: 'Nạp tiền bằng file excel',
        value: 'POST::/api/otek-dashboard/mbh-topups/upload-order-topup-by-excel',
        group: GROUP_PERMISSIONS.mbh_topups,
        name: 'Nhóm quyền quản lý nạp tiền',
    },
    {
        label: 'Nạp tiền cho số điện thoại',
        value: 'POST::/api/otek-dashboard/mbh-topups/topup-by-phone',
        group: GROUP_PERMISSIONS.mbh_topups,
        name: 'Nhóm quyền quản lý nạp tiền',
    },
    {
        label: 'Nạp tiền bằng mã đơn hàng',
        value: 'POST::/api/otek-dashboard/mbh-topups/topup-by-order-id',
        group: GROUP_PERMISSIONS.mbh_topups,
        name: 'Nhóm quyền quản lý nạp tiền',
    },
    {
        label: 'Cập nhật trạng thái giao dịch nạp tiền',
        value: 'PATCH::/api/otek-dashboard/mbh-topups/update-status-transaction-topup',
        group: GROUP_PERMISSIONS.mbh_topups,
        name: 'Nhóm quyền quản lý nạp tiền',
    },
    {
        label: 'Cập nhật khoá đơn hàng nạp tiền',
        value: 'PATCH::/api/otek-dashboard/mbh-topups/update-lock-order-topup',
        group: GROUP_PERMISSIONS.mbh_topups,
        name: 'Nhóm quyền quản lý nạp tiền',
    },

    // Mbh Tkg Dashboard
    {
        label: 'Truy vấn danh sách gói cước API gói',
        value: 'GET::/api/otek-dashboard/mbh-tkg-dashboard/get-dynamic-partner-offer',
        group: GROUP_PERMISSIONS.mbh_tkg_dashboard,
        name: 'Nhóm quyền quản lý API gói',
    },
    {
        label: 'Truy vấn danh sách đơn hàng API gói',
        value: 'GET::/api/otek-dashboard/mbh-tkg-dashboard/get-list-order-tkg-dashboard',
        group: GROUP_PERMISSIONS.mbh_tkg_dashboard,
        name: 'Nhóm quyền quản lý API gói',
    },
    {
        label: 'Truy vấn danh sách giao dịch API gói bằng mã đơn hàng',
        value: 'GET::/api/otek-dashboard/mbh-tkg-dashboard/get-list-transaction-tkg-dashboard-by-order-id',
        group: GROUP_PERMISSIONS.mbh_tkg_dashboard,
        name: 'Nhóm quyền quản lý API gói',
    },
    {
        label: 'Kiểm tra giao dịch API gói trên hệ thống',
        value: 'GET::/api/otek-dashboard/mbh-tkg-dashboard/check-transaction-tkg-dashboard-on-resource',
        group: GROUP_PERMISSIONS.mbh_tkg_dashboard,
        name: 'Nhóm quyền quản lý API gói',
    },
    {
        label: 'Kiểm tra giao dịch API gói bên đối tác',
        value: 'GET::/api/otek-dashboard/mbh-tkg-dashboard/check-transaction-tkg-dashboard-on-adapter',
        group: GROUP_PERMISSIONS.mbh_tkg_dashboard,
        name: 'Nhóm quyền quản lý API gói',
    },
    {
        label: 'Nạp tiền API gói bằng file excel',
        value: 'POST::/api/otek-dashboard/mbh-tkg-dashboard/upload-order-tkg-dashboard-by-excel',
        group: GROUP_PERMISSIONS.mbh_tkg_dashboard,
        name: 'Nhóm quyền quản lý API gói',
    },
    {
        label: 'Nạp tiền API gói cho số điện thoại',
        value: 'POST::/api/otek-dashboard/mbh-tkg-dashboard/tkg-dashboard-by-phone',
        group: GROUP_PERMISSIONS.mbh_tkg_dashboard,
        name: 'Nhóm quyền quản lý API gói',
    },
    {
        label: 'Nạp tiền API gói bằng mã đơn hàng',
        value: 'POST::/api/otek-dashboard/mbh-tkg-dashboard/tkg-dashboard-by-order-id',
        group: GROUP_PERMISSIONS.mbh_tkg_dashboard,
        name: 'Nhóm quyền quản lý API gói',
    },
    {
        label: 'Cập nhật trạng thái giao dịch API gói',
        value: 'PATCH::/api/otek-dashboard/mbh-tkg-dashboard/update-status-transaction-tkg-dashboard',
        group: GROUP_PERMISSIONS.mbh_tkg_dashboard,
        name: 'Nhóm quyền quản lý API gói',
    },
    {
        label: 'Cập nhật khoá đơn hàng API gói',
        value: 'PATCH::/api/otek-dashboard/mbh-tkg-dashboard/update-lock-order-tkg-dashboard',
        group: GROUP_PERMISSIONS.mbh_tkg_dashboard,
        name: 'Nhóm quyền quản lý API gói',
    },

    // Data Sponsor
    {
        label: 'Truy vấn danh sách gói cước data sponsor',
        value: 'GET::/api/otek-dashboard/data-sponsor/get-dynamic-partner-offer-data-sponsor',
        group: GROUP_PERMISSIONS.data_sponsor,
        name: 'Nhóm quyền quản lý data sponsor',
    },
    {
        label: 'Truy vấn danh sách đơn hàng data sponsor',
        value: 'GET::/api/otek-dashboard/data-sponsor/get-list-order-data-sponsor',
        group: GROUP_PERMISSIONS.data_sponsor,
        name: 'Nhóm quyền quản lý data sponsor',
    },
    {
        label: 'Truy vấn danh sách giao dịch data sponsor bằng mã đơn hàng',
        value: 'GET::/api/otek-dashboard/data-sponsor/get-list-transaction-data-sponsor-by-order-id',
        group: GROUP_PERMISSIONS.data_sponsor,
        name: 'Nhóm quyền quản lý data sponsor',
    },
    {
        label: 'Kiểm tra giao dịch data sponsor trên hệ thống',
        value: 'GET::/api/otek-dashboard/data-sponsor/check-transaction-data-sponsor-on-resource',
        group: GROUP_PERMISSIONS.data_sponsor,
        name: 'Nhóm quyền quản lý data sponsor',
    },
    {
        label: 'Kiểm tra giao dịch data sponsor bên đối tác',
        value: 'GET::/api/otek-dashboard/data-sponsor/check-transaction-data-sponsor-on-adapter',
        group: GROUP_PERMISSIONS.data_sponsor,
        name: 'Nhóm quyền quản lý data sponsor',
    },
    {
        label: 'Nạp tiền data sponsor bằng file excel',
        value: 'POST::/api/otek-dashboard/data-sponsor/upload-order-data-sponsor-by-excel',
        group: GROUP_PERMISSIONS.data_sponsor,
        name: 'Nhóm quyền quản lý data sponsor',
    },
    {
        label: 'Nạp tiền data sponsor cho số điện thoại',
        value: 'POST::/api/otek-dashboard/data-sponsor/data-sponsor-by-phone',
        group: GROUP_PERMISSIONS.data_sponsor,
        name: 'Nhóm quyền quản lý data sponsor',
    },
    {
        label: 'Nạp tiền data sponsor bằng mã đơn hàng',
        value: 'POST::/api/otek-dashboard/data-sponsor/data-sponsor-by-order-id',
        group: GROUP_PERMISSIONS.data_sponsor,
        name: 'Nhóm quyền quản lý data sponsor',
    },
    {
        label: 'Kiểm tra số dư data sponsor',
        value: 'GET::/api/otek-dashboard/data-sponsor/check-wallet-balance-postpaid',
        group: GROUP_PERMISSIONS.data_sponsor,
        name: 'Nhóm quyền quản lý data sponsor',
    },
    {
        label: 'Cập nhật trạng thái giao dịch data sponsor',
        value: 'PATCH::/api/otek-dashboard/data-sponsor/update-status-transaction-data-sponsor',
        group: GROUP_PERMISSIONS.data_sponsor,
        name: 'Nhóm quyền quản lý data sponsor',
    },
    {
        label: 'Cập nhật khoá đơn hàng data sponsor',
        value: 'PATCH::/api/otek-dashboard/data-sponsor/update-lock-order-data-sponsor',
        group: GROUP_PERMISSIONS.data_sponsor,
        name: 'Nhóm quyền quản lý data sponsor',
    },

    // User Partner
    {
        label: '[Đối tác] Truy vấn danh sách quản trị viên',
        value: 'GET::/api/otek-dashboard/user-partners/get-list-user-partners',
        group: GROUP_PERMISSIONS.user_partner,
        name: '[Đối tác] Nhóm quyền quản lý quản trị viên',
    },
    {
        label: '[Đối tác] Thêm quản trị viên mới',
        value: 'POST::/api/otek-dashboard/user-partners/add-user-partner',
        group: GROUP_PERMISSIONS.user_partner,
        name: '[Đối tác] Nhóm quyền quản lý quản trị viên',
    },
    {
        label: '[Đối tác] Cập nhật thông tin quản trị viên',
        value: 'PATCH::/api/otek-dashboard/user-partners/update-user-partner',
        group: GROUP_PERMISSIONS.user_partner,
        name: '[Đối tác] Nhóm quyền quản lý quản trị viên',
    },
    {
        label: '[Đối tác] Xoá quản trị viên',
        value: 'DELETE::/api/otek-dashboard/user-partners/delete-user-partner',
        group: GROUP_PERMISSIONS.user_partner,
        name: '[Đối tác] Nhóm quyền quản lý quản trị viên',
    },

    // Mbh Tkg Dashboard Partner
    {
        label: '[Đối tác] Truy vấn danh sách gói cước API gói',
        value: 'GET::/api/partner/mbh-tkg-dashboard/get-list-packages-tkg-dashboard',
        group: GROUP_PERMISSIONS.mbh_tkg_dashboard_partner,
        name: '[Đối tác] Nhóm quyền quản lý API gói',
    },
    {
        label: '[Đối tác] Truy vấn danh sách đơn hàng API gói',
        value: 'GET::/api/partner/mbh-tkg-dashboard/get-list-order-tkg-dashboard',
        group: GROUP_PERMISSIONS.mbh_tkg_dashboard_partner,
        name: '[Đối tác] Nhóm quyền quản lý API gói',
    },
    {
        label: '[Đối tác] Truy vấn danh sách giao dịch API gói bằng mã đơn hàng',
        value: 'GET::/api/partner/mbh-tkg-dashboard/get-list-transaction-tkg-dashboard-by-order-id',
        group: GROUP_PERMISSIONS.mbh_tkg_dashboard_partner,
        name: '[Đối tác] Nhóm quyền quản lý API gói',
    },
    {
        label: '[Đối tác] Kiểm tra giao dịch API gói trên hệ thống',
        value: 'GET::/api/partner/mbh-tkg-dashboard/check-transaction-tkg-dashboard-on-resource',
        group: GROUP_PERMISSIONS.mbh_tkg_dashboard_partner,
        name: '[Đối tác] Nhóm quyền quản lý API gói',
    },
    {
        label: '[Đối tác] Kiểm tra giao dịch API gói bên đối tác',
        value: 'GET::/api/partner/mbh-tkg-dashboard/check-transaction-tkg-dashboard-on-adapter',
        group: GROUP_PERMISSIONS.mbh_tkg_dashboard_partner,
        name: '[Đối tác] Nhóm quyền quản lý API gói',
    },
    {
        label: '[Đối tác] Nạp tiền API gói bằng file excel',
        value: 'POST::/api/partner/mbh-tkg-dashboard/upload-order-tkg-dashboard-by-excel',
        group: GROUP_PERMISSIONS.mbh_tkg_dashboard_partner,
        name: '[Đối tác] Nhóm quyền quản lý API gói',
    },
    {
        label: '[Đối tác] Nạp tiền API gói cho số điện thoại',
        value: 'POST::/api/partner/mbh-tkg-dashboard/tkg-dashboard-by-phone',
        group: GROUP_PERMISSIONS.mbh_tkg_dashboard_partner,
        name: '[Đối tác] Nhóm quyền quản lý API gói',
    },
    {
        label: '[Đối tác] Nạp tiền API gói bằng mã đơn hàng',
        value: 'POST::/api/partner/mbh-tkg-dashboard/tkg-dashboard-by-order-id',
        group: GROUP_PERMISSIONS.mbh_tkg_dashboard_partner,
        name: '[Đối tác] Nhóm quyền quản lý API gói',
    },

    // Transaction Connection
    {
        label: 'Truy vấn danh sách giao dịch đấu nối',
        value: 'GET::/api/otek-dashboard/transaction-connection/get-list-transaction-connection',
        group: GROUP_PERMISSIONS.transaction_connection,
        name: 'Nhóm quyền quản lý giao dịch đấu nối',
    },
    {
        label: 'Thêm danh sách giao dịch đấu nối',
        value: 'POST::/api/otek-dashboard/transaction-connection/add-list-transaction-connection',
        group: GROUP_PERMISSIONS.transaction_connection,
        name: 'Nhóm quyền quản lý giao dịch đấu nối',
    },
    {
        label: 'Cập nhật danh sách giao dịch đấu nối',
        value: 'PUT::/api/otek-dashboard/transaction-connection/update-list-transaction-connection',
        group: GROUP_PERMISSIONS.transaction_connection,
        name: 'Nhóm quyền quản lý giao dịch đấu nối',
    },
    {
        label: 'Thêm giao dịch đấu nối bằng cú pháp',
        value: 'POST::/api/otek-dashboard/transaction-connection/add-transaction-connection',
        group: GROUP_PERMISSIONS.transaction_connection,
        name: 'Nhóm quyền quản lý giao dịch đấu nối',
    },
    {
        label: 'Cập nhật danh sách sim',
        value: 'PUT::/api/otek-dashboard/transaction-connection/update-list-sim-transaction-connection',
        group: GROUP_PERMISSIONS.transaction_connection,
        name: 'Nhóm quyền quản lý giao dịch đấu nối',
    },
    {
        label: 'Cập nhật thông tin số điện thoại',
        value: 'PUT::/api/otek-dashboard/transaction-connection/update-phone-number-transaction-connection',
        group: GROUP_PERMISSIONS.transaction_connection,
        name: 'Nhóm quyền quản lý giao dịch đấu nối',
    },
    {
        label: 'Cập nhật thông tin gói cước',
        value: 'PUT::/api/otek-dashboard/transaction-connection/update-data-pack-transaction-connection',
        group: GROUP_PERMISSIONS.transaction_connection,
        name: 'Nhóm quyền quản lý giao dịch đấu nối',
    },
    {
        label: 'Cập nhật giao dịch thất bại',
        value: 'PUT::/api/otek-dashboard/transaction-connection/update-failed-transaction-connection',
        group: GROUP_PERMISSIONS.transaction_connection,
        name: 'Nhóm quyền quản lý giao dịch đấu nối',
    },
    {
        label: 'Truy vấn danh sách giao dịch hết hạn',
        value: 'GET::/api/otek-dashboard/transaction-connection/get-list-transaction-connection-expire',
        group: GROUP_PERMISSIONS.transaction_connection,
        name: 'Nhóm quyền quản lý giao dịch đấu nối',
    },
    {
        label: 'Truy vấn danh sách giao dịch đấu nối view',
        value: 'GET::/api/otek-dashboard/transaction-connection/get-list-transaction-connection-view',
        group: GROUP_PERMISSIONS.transaction_connection,
        name: 'Nhóm quyền quản lý giao dịch đấu nối',
    },
    {
        label: 'Truy vấn danh sách giao dịch đấu nối bằng ids',
        value: 'POST::/api/otek-dashboard/transaction-connection/get-list-transaction-connection-by-ids',
        group: GROUP_PERMISSIONS.transaction_connection,
        name: 'Nhóm quyền quản lý giao dịch đấu nối',
    },

    // Registration Request
    {
        label: 'Truy vấn danh sách yêu cầu đấu nối',
        value: 'GET::/api/otek-dashboard/registration-request/get-list-registration-requests',
        group: GROUP_PERMISSIONS.registration_request,
        name: 'Nhóm quyền quản lý yêu cầu đấu nối',
    },
    {
        label: 'Thêm danh sách yêu cầu đấu nối',
        value: 'POST::/api/otek-dashboard/registration-request/add-list-registration-requests',
        group: GROUP_PERMISSIONS.registration_request,
        name: 'Nhóm quyền quản lý yêu cầu đấu nối',
    },
    {
        label: 'Cập nhật danh sách yêu cầu đấu nối',
        value: 'PUT::/api/otek-dashboard/registration-request/update-list-registration-requests',
        group: GROUP_PERMISSIONS.registration_request,
        name: 'Nhóm quyền quản lý yêu cầu đấu nối',
    },
    {
        label: 'Xoá danh sách yêu cầu đấu nối',
        value: 'DELETE::/api/otek-dashboard/registration-request/delete-list-registration-requests',
        group: GROUP_PERMISSIONS.registration_request,
        name: 'Nhóm quyền quản lý yêu cầu đấu nối',
    },

    // Order Transaction Connection
    {
        label: 'Truy vấn danh sách đơn hàng đấu nối',
        value: 'GET::/api/otek-dashboard/order-transaction-connection/get-list-order-transaction-connection',
        group: GROUP_PERMISSIONS.order_transaction_connection,
        name: 'Nhóm quyền quản lý đơn hàng đấu nối',
    },
    {
        label: 'Truy vấn chi tiết đơn hàng đấu nối',
        value: 'GET::/api/otek-dashboard/order-transaction-connection/get-order-transaction-connection-detail',
        group: GROUP_PERMISSIONS.order_transaction_connection,
        name: 'Nhóm quyền quản lý đơn hàng đấu nối',
    },
    {
        label: 'Thêm giao dịch đấu nối bằng file excel',
        value: 'POST::/api/otek-dashboard/order-transaction-connection/upload-order-transaction-connection-by-excel',
        group: GROUP_PERMISSIONS.order_transaction_connection,
        name: 'Nhóm quyền quản lý đơn hàng đấu nối',
    },
    {
        label: 'Thêm giao dịch đấu nối bằng mã đơn hàng',
        value: 'POST::/api/otek-dashboard/order-transaction-connection/add-transaction-connection-by-order-id',
        group: GROUP_PERMISSIONS.order_transaction_connection,
        name: 'Nhóm quyền quản lý đơn hàng đấu nối',
    },
    {
        label: 'Cập nhật đơn hàng đấu nối',
        value: 'PUT::/api/otek-dashboard/order-transaction-connection/update-order-transaction-connection',
        group: GROUP_PERMISSIONS.order_transaction_connection,
        name: 'Nhóm quyền quản lý đơn hàng đấu nối',
    },

    // Statistical Service
    {
        label: 'Truy vấn thông tin doanh thu',
        value: 'GET::/api/otek-dashboard/statistical-service/get-revenue-connection',
        group: GROUP_PERMISSIONS.statistical_service,
        name: 'Nhóm quyền quản lý thống kê',
    },
    {
        label: 'Truy vấn thông tin doanh thu theo ngày',
        value: 'GET::/api/otek-dashboard/statistical-service/get-revenue-date-connection',
        group: GROUP_PERMISSIONS.statistical_service,
        name: 'Nhóm quyền quản lý thống kê',
    },
    {
        label: 'Truy vấn thông tin đấu nối theo loại',
        value: 'GET::/api/otek-dashboard/statistical-service/get-statistical-type-connection',
        group: GROUP_PERMISSIONS.statistical_service,
        name: 'Nhóm quyền quản lý thống kê',
    },
    {
        label: 'Truy vấn thông tin đấu nối theo ngày',
        value: 'GET::/api/otek-dashboard/statistical-service/get-statistical-date-connection',
        group: GROUP_PERMISSIONS.statistical_service,
        name: 'Nhóm quyền quản lý thống kê',
    },
    {
        label: 'Truy vấn thông tin đấu nối theo chu kỳ gói',
        value: 'GET::/api/otek-dashboard/statistical-service/get-statistical-pack-duration-connection',
        group: GROUP_PERMISSIONS.statistical_service,
        name: 'Nhóm quyền quản lý thống kê',
    },
    {
        label: 'Truy vấn thông tin đấu nối hết hạn theo loại',
        value: 'GET::/api/otek-dashboard/statistical-service/get-statistical-type-expiration',
        group: GROUP_PERMISSIONS.statistical_service,
        name: 'Nhóm quyền quản lý thống kê',
    },
    {
        label: 'Truy vấn thông tin đấu nối hết hạn theo ngày',
        value: 'GET::/api/otek-dashboard/statistical-service/get-statistical-date-expiration',
        group: GROUP_PERMISSIONS.statistical_service,
        name: 'Nhóm quyền quản lý thống kê',
    },
    {
        label: 'Truy vấn thông tin đấu nối gia hạn theo ngày',
        value: 'GET::/api/otek-dashboard/statistical-service/get-statistical-date-extension',
        group: GROUP_PERMISSIONS.statistical_service,
        name: 'Nhóm quyền quản lý thống kê',
    },
    {
        label: 'Tính toán lại thống kê',
        value: 'PATCH::/api/otek-dashboard/statistical-service/recalculate-statistics',
        group: GROUP_PERMISSIONS.statistical_service,
        name: 'Nhóm quyền quản lý thống kê',
    },
    {
        label: 'Truy vấn thông tin cuộc gọi theo tháng',
        value: 'GET::/api/otek-dashboard/statistical-service/get-statistical-date-calling',
        group: GROUP_PERMISSIONS.statistical_service,
        name: 'Nhóm quyền quản lý thống kê',
    },
    {
        label: 'Truy vấn thông tin cuộc gọi theo loại',
        value: 'GET::/api/otek-dashboard/statistical-service/get-statistical-type-calling',
        group: GROUP_PERMISSIONS.statistical_service,
        name: 'Nhóm quyền quản lý thống kê',
    },
    {
        label: 'Truy vấn thông tin cuộc gọi TeleSale',
        value: 'GET::/api/otek-dashboard/statistical-service/get-statistical-telesale-calling',
        group: GROUP_PERMISSIONS.statistical_service,
        name: 'Nhóm quyền quản lý thống kê',
    },

    // Customer Resource
    {
        label: 'Truy vấn danh sách khách hàng đấu nối',
        value: 'GET::/api/otek-dashboard/customer-resource/get-list-customer-resource',
        group: GROUP_PERMISSIONS.customer_resource,
        name: 'Nhóm quyền quản lý khách hàng đấu nối',
    },
    {
        label: 'Thêm danh sách khách hàng đấu nối',
        value: 'POST::/api/otek-dashboard/customer-resource/add-list-customer-resource',
        group: GROUP_PERMISSIONS.customer_resource,
        name: 'Nhóm quyền quản lý khách hàng đấu nối',
    },
    {
        label: 'Cập nhật danh sách khách hàng đấu nối',
        value: 'PUT::/api/otek-dashboard/customer-resource/update-list-customer-resource',
        group: GROUP_PERMISSIONS.customer_resource,
        name: 'Nhóm quyền quản lý khách hàng đấu nối',
    },

    // Phone Agency
    {
        label: 'Truy vấn danh sách đại lý đấu nối',
        value: 'GET::/api/otek-dashboard/phone-agencies/get-list-phone-agencies',
        group: GROUP_PERMISSIONS.phone_agency,
        name: 'Nhóm quyền quản lý đại lý đấu nối',
    },
    {
        label: 'Thêm danh sách đại lý đấu nối',
        value: 'POST::/api/otek-dashboard/phone-agencies/add-list-phone-agencies',
        group: GROUP_PERMISSIONS.phone_agency,
        name: 'Nhóm quyền quản lý đại lý đấu nối',
    },
    {
        label: 'Cập nhật danh sách đại lý đấu nối',
        value: 'PUT::/api/otek-dashboard/phone-agencies/update-list-phone-agencies',
        group: GROUP_PERMISSIONS.phone_agency,
        name: 'Nhóm quyền quản lý đại lý đấu nối',
    },

    // Call Info
    {
        label: 'Truy vấn danh sách cuộc gọi',
        value: 'GET::/api/otek-dashboard/call-info/get-list-call-info',
        group: GROUP_PERMISSIONS.call_info,
        name: 'Nhóm quyền quản lý cuộc gọi',
    },
    {
        label: 'Truy vấn danh sách chi tiết cuộc gọi',
        value: 'GET::/api/otek-dashboard/call-info/get-list-call-info-detail',
        group: GROUP_PERMISSIONS.call_info,
        name: 'Nhóm quyền quản lý cuộc gọi',
    },
    {
        label: 'Thêm danh sách cuộc gọi',
        value: 'POST::/api/otek-dashboard/call-info/add-list-call-telesale',
        group: GROUP_PERMISSIONS.call_info,
        name: 'Nhóm quyền quản lý cuộc gọi',
    },
    {
        label: 'Thêm phản hồi cho đối tác',
        value: 'POST::/api/otek-dashboard/call-info/add-log-feedback',
        group: GROUP_PERMISSIONS.call_info,
        name: 'Nhóm quyền quản lý cuộc gọi',
    },
    {
        label: 'Cập nhật danh sách cuộc gọi',
        value: 'PUT::/api/otek-dashboard/call-info/update-list-call-info',
        group: GROUP_PERMISSIONS.call_info,
        name: 'Nhóm quyền quản lý cuộc gọi',
    },

    // Call Log
    {
        label: 'Truy vấn danh sách cuộc gọi cuối',
        value: 'GET::/api/otek-dashboard/call-log/get-list-call-log',
        group: GROUP_PERMISSIONS.call_info,
        name: 'Nhóm quyền quản lý cuộc gọi',
    },
    {
        label: 'Thêm danh sách cuộc gọi cuối',
        value: 'POST::/api/otek-dashboard/call-log/add-list-call-log',
        group: GROUP_PERMISSIONS.call_info,
        name: 'Nhóm quyền quản lý cuộc gọi',
    },
    {
        label: 'Cập nhật danh sách cuộc gọi cuối',
        value: 'PUT::/api/otek-dashboard/call-log/update-list-call-log',
        group: GROUP_PERMISSIONS.call_info,
        name: 'Nhóm quyền quản lý cuộc gọi',
    },

    // Inventory Service
    {
        label: 'Thêm đơn hàng vào kho xuất',
        value: 'POST::/api/otek-dashboard/mbh-inventory/add-order-inventory',
        group: GROUP_PERMISSIONS.inventory_service,
        name: 'Nhóm quyền quản lý kho sim',
    },
    {
        label: 'Truy vấn danh sách đơn hàng trong kho xuất',
        value: 'GET::/api/otek-dashboard/mbh-inventory/get-list-order-inventory',
        group: GROUP_PERMISSIONS.inventory_service,
        name: 'Nhóm quyền quản lý kho sim',
    },
    {
        label: 'Hiển thị menu Đơn hàng (Kho xuất)',
        value: 'VIEW::/page/export-order',
        group: GROUP_PERMISSIONS.inventory_service,
        name: 'Nhóm quyền quản lý kho sim',
    },
    {
        label: 'Cập nhật đơn hàng vào kho xuất',
        value: 'PUT::/api/otek-dashboard/mbh-inventory/update-order-inventory',
        group: GROUP_PERMISSIONS.inventory_service,
        name: 'Nhóm quyền quản lý kho sim',
    },
    {
        label: 'Truy vấn danh sách sim trong kho',
        value: 'GET::/api/otek-dashboard/mbh-inventory/get-list-sim-inventory',
        group: GROUP_PERMISSIONS.inventory_service,
        name: 'Nhóm quyền quản lý kho sim',
    },
    {
        label: 'Truy vấn sim trong kho bằng danh sách mã đơn hàng',
        value: 'POST::/api/otek-dashboard/mbh-inventory/get-sim-inventory-by-order-ids',
        group: GROUP_PERMISSIONS.inventory_service,
        name: 'Nhóm quyền quản lý kho sim',
    },
    {
        label: 'Cập nhật sim trong kho',
        value: 'PUT::/api/otek-dashboard/mbh-inventory/update-sim-inventory',
        group: GROUP_PERMISSIONS.inventory_service,
        name: 'Nhóm quyền quản lý kho sim',
    },
    {
        label: 'Thêm đơn hàng vào kho nhập',
        value: 'POST::/api/otek-dashboard/mbh-inventory/add-order-warehouse',
        group: GROUP_PERMISSIONS.inventory_service,
        name: 'Nhóm quyền quản lý kho sim',
    },
    {
        label: 'Truy vấn danh sách đơn hàng trong kho nhập',
        value: 'GET::/api/otek-dashboard/mbh-inventory/get-list-order-warehouse',
        group: GROUP_PERMISSIONS.inventory_service,
        name: 'Nhóm quyền quản lý kho sim',
    },
    {
        label: 'Cập nhật đơn hàng vào kho nhập',
        value: 'PUT::/api/otek-dashboard/mbh-inventory/update-order-warehouse',
        group: GROUP_PERMISSIONS.inventory_service,
        name: 'Nhóm quyền quản lý kho sim',
    },
    {
        label: 'Thêm đơn hàng bán lẻ vào kho xuất',
        value: 'POST::/api/otek-dashboard/mbh-sales-inventory/add-sales-order',
        group: GROUP_PERMISSIONS.sales_inventory_service,
        name: 'Nhóm quyền quản lý kho sim bán lẻ',
    },
    {
        label: 'Bổ sung thông tin bán lẻ cho đơn có sẵn',
        value: 'POST::/api/otek-dashboard/mbh-sales-inventory/add-sales-order-info',
        group: GROUP_PERMISSIONS.sales_inventory_service,
        name: 'Nhóm quyền quản lý kho sim bán lẻ',
    },
    {
        label: 'Truy vấn danh sách đơn hàng bán lẻ',
        value: 'GET::/api/otek-dashboard/mbh-sales-inventory/get-list-sales-order',
        group: GROUP_PERMISSIONS.sales_inventory_service,
        name: 'Nhóm quyền quản lý kho sim bán lẻ',
    },
    {
        label: 'Hiển thị menu Đơn hàng bán lẻ (Kho xuất)',
        value: 'VIEW::/page/export-sales-order',
        group: GROUP_PERMISSIONS.sales_inventory_service,
        name: 'Nhóm quyền quản lý kho sim bán lẻ',
    },
    {
        label: 'Cập nhật đơn hàng bán lẻ',
        value: 'PUT::/api/otek-dashboard/mbh-sales-inventory/update-sales-order',
        group: GROUP_PERMISSIONS.sales_inventory_service,
        name: 'Nhóm quyền quản lý kho sim bán lẻ',
    },

    // Config
    {
        label: 'Truy vấn danh sách cấu hình cho đối tác',
        value: 'GET::/api/otek-dashboard/config/get-list-partner-config',
        group: GROUP_PERMISSIONS.config,
        name: 'Nhóm quyền quản lý cấu hình',
    },
    {
        label: 'Thêm danh sách cấu hình cho đối tác',
        value: 'POST::/api/otek-dashboard/config/add-list-partner-config',
        group: GROUP_PERMISSIONS.config,
        name: 'Nhóm quyền quản lý cấu hình',
    },
    {
        label: 'Cập nhật danh sách cấu hình cho đối tác',
        value: 'PUT::/api/otek-dashboard/config/update-list-partner-config',
        group: GROUP_PERMISSIONS.config,
        name: 'Nhóm quyền quản lý cấu hình',
    },
    {
        label: 'Truy vấn danh sách phiên bản cập nhật',
        value: 'GET::/api/otek-dashboard/config/get-list-versions',
        group: GROUP_PERMISSIONS.config,
        name: 'Nhóm quyền quản lý cấu hình',
    },
    {
        label: 'Thêm danh sách phiên bản cập nhật',
        value: 'POST::/api/otek-dashboard/config/add-list-versions',
        group: GROUP_PERMISSIONS.config,
        name: 'Nhóm quyền quản lý cấu hình',
    },
    {
        label: 'Cập nhật danh sách phiên bản cập nhật',
        value: 'PUT::/api/otek-dashboard/config/update-list-versions',
        group: GROUP_PERMISSIONS.config,
        name: 'Nhóm quyền quản lý cấu hình',
    },
    {
        label: 'Xoá danh sách phiên bản cập nhật',
        value: 'DELETE::/api/otek-dashboard/config/delete-list-versions',
        group: GROUP_PERMISSIONS.config,
        name: 'Nhóm quyền quản lý cấu hình',
    },
    {
        label: 'Truy vấn danh sách tài khoản ngân hàng',
        value: 'GET::/api/otek-dashboard/config/get-list-bank-accounts',
        group: GROUP_PERMISSIONS.config,
        name: 'Nhóm quyền quản lý cấu hình',
    },
    {
        label: 'Thêm danh sách tài khoản ngân hàng',
        value: 'POST::/api/otek-dashboard/config/add-list-bank-accounts',
        group: GROUP_PERMISSIONS.config,
        name: 'Nhóm quyền quản lý cấu hình',
    },
    {
        label: 'Cập nhật danh sách tài khoản ngân hàng',
        value: 'PUT::/api/otek-dashboard/config/update-list-bank-accounts',
        group: GROUP_PERMISSIONS.config,
        name: 'Nhóm quyền quản lý cấu hình',
    },
    {
        label: 'Truy vấn danh sách cấu hình nạp tiền',
        value: 'GET::/api/otek-dashboard/config/get-list-top-up-config',
        group: GROUP_PERMISSIONS.config,
        name: 'Nhóm quyền quản lý cấu hình',
    },
    {
        label: 'Thêm danh sách cấu hình nạp tiền',
        value: 'POST::/api/otek-dashboard/config/add-list-top-up-config',
        group: GROUP_PERMISSIONS.config,
        name: 'Nhóm quyền quản lý cấu hình',
    },
    {
        label: 'Cập nhật danh sách cấu hình nạp tiền',
        value: 'PUT::/api/otek-dashboard/config/update-list-top-up-config',
        group: GROUP_PERMISSIONS.config,
        name: 'Nhóm quyền quản lý cấu hình',
    },
    {
        label: 'Truy vấn danh sách cấu hình API gói',
        value: 'GET::/api/otek-dashboard/config/get-list-tkg-config',
        group: GROUP_PERMISSIONS.config,
        name: 'Nhóm quyền quản lý cấu hình',
    },
    {
        label: 'Thêm danh sách cấu hình API gói',
        value: 'POST::/api/otek-dashboard/config/add-list-tkg-config',
        group: GROUP_PERMISSIONS.config,
        name: 'Nhóm quyền quản lý cấu hình',
    },
    {
        label: 'Cập nhật danh sách cấu hình API gói',
        value: 'PUT::/api/otek-dashboard/config/update-list-tkg-config',
        group: GROUP_PERMISSIONS.config,
        name: 'Nhóm quyền quản lý cấu hình',
    },
    {
        label: 'Truy vấn danh sách thiết bị',
        value: 'GET::/api/otek-dashboard/config/get-list-devices',
        group: GROUP_PERMISSIONS.config,
        name: 'Nhóm quyền quản lý cấu hình',
    },
    {
        label: 'Thêm danh sách thiết bị',
        value: 'POST::/api/otek-dashboard/config/add-list-devices',
        group: GROUP_PERMISSIONS.config,
        name: 'Nhóm quyền quản lý cấu hình',
    },
    {
        label: 'Cập nhật danh sách thiết bị',
        value: 'PUT::/api/otek-dashboard/config/update-list-devices',
        group: GROUP_PERMISSIONS.config,
        name: 'Nhóm quyền quản lý cấu hình',
    },
    {
        label: 'Xoá danh sách thiết bị',
        value: 'DELETE::/api/otek-dashboard/config/delete-list-devices',
        group: GROUP_PERMISSIONS.config,
        name: 'Nhóm quyền quản lý cấu hình',
    },
    {
        label: 'Truy vấn danh sách cấu hình cho telesale',
        value: 'GET::/api/otek-dashboard/config/get-list-telesale-config',
        group: GROUP_PERMISSIONS.config,
        name: 'Nhóm quyền quản lý cấu hình',
    },
    {
        label: 'Thêm danh sách cấu hình cho telesale',
        value: 'POST::/api/otek-dashboard/config/add-list-telesale-config',
        group: GROUP_PERMISSIONS.config,
        name: 'Nhóm quyền quản lý cấu hình',
    },
    {
        label: 'Cập nhật danh sách cấu hình cho telesale',
        value: 'PUT::/api/otek-dashboard/config/update-list-telesale-config',
        group: GROUP_PERMISSIONS.config,
        name: 'Nhóm quyền quản lý cấu hình',
    },
    {
        label: 'Truy vấn danh sách cấu hình cho hóa đơn',
        value: 'GET::/api/otek-dashboard/config/get-list-invoice-config',
        group: GROUP_PERMISSIONS.config,
        name: 'Nhóm quyền quản lý cấu hình',
    },
    {
        label: 'Thêm danh sách cấu hình cho hóa đơn',
        value: 'POST::/api/otek-dashboard/config/add-list-invoice-config',
        group: GROUP_PERMISSIONS.config,
        name: 'Nhóm quyền quản lý cấu hình',
    },
    {
        label: 'Cập nhật danh sách cấu hình cho hóa đơn',
        value: 'PUT::/api/otek-dashboard/config/update-list-invoice-config',
        group: GROUP_PERMISSIONS.config,
        name: 'Nhóm quyền quản lý cấu hình',
    },
    {
        label: 'Truy vấn danh sách cấu hình SANN',
        value: 'GET::/api/otek-dashboard/config/get-list-sann-config',
        group: GROUP_PERMISSIONS.config,
        name: 'Nhóm quyền quản lý cấu hình',
    },
    {
        label: 'Thêm danh sách cấu hình SANN',
        value: 'POST::/api/otek-dashboard/config/add-list-sann-config',
        group: GROUP_PERMISSIONS.config,
        name: 'Nhóm quyền quản lý cấu hình',
    },
    {
        label: 'Cập nhật danh sách cấu hình SANN',
        value: 'PUT::/api/otek-dashboard/config/update-list-sann-config',
        group: GROUP_PERMISSIONS.config,
        name: 'Nhóm quyền quản lý cấu hình',
    },

    // Invoice
    {
        label: 'Truy vấn loại hóa đơn adapter',
        value: 'GET::/api/otek-dashboard/invoice/get-type-invoice-adapter',
        group: GROUP_PERMISSIONS.invoice,
        name: 'Nhóm quyền quản lý hóa đơn',
    },
    {
        label: 'Truy vấn thông tin hóa đơn adapter',
        value: 'GET::/api/otek-dashboard/invoice/get-invoice-adapter',
        group: GROUP_PERMISSIONS.invoice,
        name: 'Nhóm quyền quản lý hóa đơn',
    },
    {
        label: 'Truy vấn danh sách hóa đơn adapter',
        value: 'GET::/api/otek-dashboard/invoice/get-list-invoice-adapter',
        group: GROUP_PERMISSIONS.invoice,
        name: 'Nhóm quyền quản lý hóa đơn',
    },
    {
        label: 'Truy vấn in hóa đơn adapter',
        value: 'GET::/api/otek-dashboard/invoice/get-print-invoice-adapter',
        group: GROUP_PERMISSIONS.invoice,
        name: 'Nhóm quyền quản lý hóa đơn',
    },
    {
        label: 'Truy vấn danh sách hóa đơn',
        value: 'GET::/api/otek-dashboard/invoice/get-list-invoices',
        group: GROUP_PERMISSIONS.invoice,
        name: 'Nhóm quyền quản lý hóa đơn',
    },
    {
        label: 'Thêm hóa đơn',
        value: 'POST::/api/otek-dashboard/invoice/add-invoice',
        group: GROUP_PERMISSIONS.invoice,
        name: 'Nhóm quyền quản lý hóa đơn',
    },
    {
        label: 'Thêm hóa đơn theo form',
        value: 'POST::/api/otek-dashboard/invoice/add-invoice-by-form',
        group: GROUP_PERMISSIONS.invoice,
        name: 'Nhóm quyền quản lý hóa đơn',
    },
    {
        label: 'Cập nhật hóa đơn',
        value: 'PUT::/api/otek-dashboard/invoice/update-invoice',
        group: GROUP_PERMISSIONS.invoice,
        name: 'Nhóm quyền quản lý hóa đơn',
    },
    {
        label: 'Xoá hóa đơn',
        value: 'DELETE::/api/otek-dashboard/invoice/delete-invoice',
        group: GROUP_PERMISSIONS.invoice,
        name: 'Nhóm quyền quản lý hóa đơn',
    },
    {
        label: 'Truy vấn danh sách template hóa đơn',
        value: 'GET::/api/otek-dashboard/invoice/get-list-invoice-templates',
        group: GROUP_PERMISSIONS.invoice,
        name: 'Nhóm quyền quản lý hóa đơn',
    },
    {
        label: 'Thêm danh sách template hóa đơn',
        value: 'POST::/api/otek-dashboard/invoice/add-list-invoice-templates',
        group: GROUP_PERMISSIONS.invoice,
        name: 'Nhóm quyền quản lý hóa đơn',
    },
    {
        label: 'Cập nhật danh sách template hóa đơn',
        value: 'PUT::/api/otek-dashboard/invoice/update-list-invoice-templates',
        group: GROUP_PERMISSIONS.invoice,
        name: 'Nhóm quyền quản lý hóa đơn',
    },
    {
        label: 'Xoá danh sách template hóa đơn',
        value: 'DELETE::/api/otek-dashboard/invoice/delete-list-invoice-templates',
        group: GROUP_PERMISSIONS.invoice,
        name: 'Nhóm quyền quản lý hóa đơn',
    },
    {
        label: 'Truy vấn danh sách template-item hóa đơn',
        value: 'GET::/api/otek-dashboard/invoice/get-list-invoice-template-items',
        group: GROUP_PERMISSIONS.invoice,
        name: 'Nhóm quyền quản lý hóa đơn',
    },
    {
        label: 'Thêm danh sách template-item hóa đơn',
        value: 'POST::/api/otek-dashboard/invoice/add-list-invoice-template-items',
        group: GROUP_PERMISSIONS.invoice,
        name: 'Nhóm quyền quản lý hóa đơn',
    },
    {
        label: 'Cập nhật danh sách template-item hóa đơn',
        value: 'PUT::/api/otek-dashboard/invoice/update-list-invoice-template-items',
        group: GROUP_PERMISSIONS.invoice,
        name: 'Nhóm quyền quản lý hóa đơn',
    },
    {
        label: 'Xoá danh sách template-item hóa đơn',
        value: 'DELETE::/api/otek-dashboard/invoice/delete-list-invoice-template-items',
        group: GROUP_PERMISSIONS.invoice,
        name: 'Nhóm quyền quản lý hóa đơn',
    },
    {
        label: 'Thêm hóa đơn adapter bằng invoiceId',
        value: 'POST::/api/otek-dashboard/invoice/add-invoice-adapter-by-invoice-id',
        group: GROUP_PERMISSIONS.invoice,
        name: 'Nhóm quyền quản lý hóa đơn',
    },

    // Report
    {
        label: 'Tạo báo cáo đơn hàng nạp tiền',
        value: 'POST::/api/otek-dashboard/report/download-order-topups',
        group: GROUP_PERMISSIONS.report,
        name: 'Nhóm quyền xuất báo cáo',
    },
    {
        label: 'Kiểm tra trạng thái báo cáo',
        value: 'GET::/api/otek-dashboard/report/report-status',
        group: GROUP_PERMISSIONS.report,
        name: 'Nhóm quyền xuất báo cáo',
    },
    {
        label: 'Tải xuống báo cáo',
        value: 'GET::/api/otek-dashboard/report/report-download',
        group: GROUP_PERMISSIONS.report,
        name: 'Nhóm quyền xuất báo cáo',
    },
    {
        label: 'Tạo báo cáo đấu nối SIM ',
        value: 'POST::/api/otek-dashboard/report/download-transaction-connection',
        group: GROUP_PERMISSIONS.report,
        name: 'Nhóm quyền xuất báo cáo',
    },

    // zalo account service
    {
        label: 'Truy vấn danh sách tài khoản Zalo',
        value: 'GET::/api/otek-dashboard/zalo-account-service/get-list-zalo-accounts',
        group: GROUP_PERMISSIONS.zalo_account,
        name: 'Nhóm quyền quản lý tài khoản Zalo',
    },
    {
        label: 'Thêm danh sách tài khoản Zalo',
        value: 'POST::/api/otek-dashboard/zalo-account-service/add-list-zalo-accounts',
        group: GROUP_PERMISSIONS.zalo_account,
        name: 'Nhóm quyền quản lý tài khoản Zalo',
    },
    {
        label: 'Cập nhật danh sách tài khoản Zalo',
        value: 'PUT::/api/otek-dashboard/zalo-account-service/update-list-zalo-accounts',
        group: GROUP_PERMISSIONS.zalo_account,
        name: 'Nhóm quyền quản lý tài khoản Zalo',
    },
    {
        label: 'Xoá danh sách tài khoản Zalo',
        value: 'DELETE::/api/otek-dashboard/zalo-account-service/delete-list-zalo-accounts',
        group: GROUP_PERMISSIONS.zalo_account,
        name: 'Nhóm quyền quản lý tài khoản Zalo',
    },
    {
        label: 'Truy vấn danh sách session Zalo',
        value: 'GET::/api/otek-dashboard/zalo-account-service/get-list-zalo-account-sessions',
        group: GROUP_PERMISSIONS.zalo_account,
        name: 'Nhóm quyền quản lý tài khoản Zalo',
    },
    {
        label: 'Thêm danh sách session Zalo',
        value: 'POST::/api/otek-dashboard/zalo-account-service/add-list-zalo-account-sessions',
        group: GROUP_PERMISSIONS.zalo_account,
        name: 'Nhóm quyền quản lý tài khoản Zalo',
    },
    {
        label: 'Cập nhật danh sách session Zalo',
        value: 'PUT::/api/otek-dashboard/zalo-account-service/update-list-zalo-account-sessions',
        group: GROUP_PERMISSIONS.zalo_account,
        name: 'Nhóm quyền quản lý tài khoản Zalo',
    },
    {
        label: 'Kiểm tra phiên Zalo còn hoạt động',
        value: 'GET::/api/otek-dashboard/zalo-account-service/check-session-active',
        group: GROUP_PERMISSIONS.zalo_account,
        name: 'Nhóm quyền quản lý tài khoản Zalo',
    },
    {
        label: 'Lấy credentials phiên Zalo (verify thật)',
        value: 'GET::/api/otek-dashboard/zalo-account-service/get-session-credentials',
        group: GROUP_PERMISSIONS.zalo_account,
        name: 'Nhóm quyền quản lý tài khoản Zalo',
    },
    {
        label: 'Ghi nhận kết quả verify phiên Zalo',
        value: 'POST::/api/otek-dashboard/zalo-account-service/log-verify-session',
        group: GROUP_PERMISSIONS.zalo_account,
        name: 'Nhóm quyền quản lý tài khoản Zalo',
    },
    {
        label: 'Truy vấn danh sách phân quyền Zalo',
        value: 'GET::/api/otek-dashboard/zalo-account-service/get-list-zalo-account-user-permissions',
        group: GROUP_PERMISSIONS.zalo_account,
        name: 'Nhóm quyền quản lý tài khoản Zalo',
    },
    {
        label: 'Cấp quyền truy cập Zalo cho user',
        value: 'POST::/api/otek-dashboard/zalo-account-service/add-list-zalo-account-user-permissions',
        group: GROUP_PERMISSIONS.zalo_account,
        name: 'Nhóm quyền quản lý tài khoản Zalo',
    },
    {
        label: 'Đổi level/chuyển primary phân quyền Zalo',
        value: 'PUT::/api/otek-dashboard/zalo-account-service/update-list-zalo-account-user-permissions',
        group: GROUP_PERMISSIONS.zalo_account,
        name: 'Nhóm quyền quản lý tài khoản Zalo',
    },
    {
        label: 'Thu hồi phân quyền Zalo',
        value: 'DELETE::/api/otek-dashboard/zalo-account-service/delete-list-zalo-account-user-permissions',
        group: GROUP_PERMISSIONS.zalo_account,
        name: 'Nhóm quyền quản lý tài khoản Zalo',
    },
    {
        label: 'Hoàn tất đăng nhập Zalo (saga)',
        value: 'POST::/api/otek-dashboard/zalo-account-service/complete-zalo-login',
        group: GROUP_PERMISSIONS.zalo_account,
        name: 'Nhóm quyền quản lý tài khoản Zalo',
    },
    {
        label: 'Chuyển primary owner Zalo account',
        value: 'POST::/api/otek-dashboard/zalo-account-service/transfer-primary-ownership',
        group: GROUP_PERMISSIONS.zalo_account,
        name: 'Nhóm quyền quản lý tài khoản Zalo',
    },
    {
        label: 'Đồng bộ danh sách bạn bè Zalo',
        value: 'POST::/api/otek-dashboard/zalo-account-service/sync-zalo-account-friends',
        group: GROUP_PERMISSIONS.zalo_account,
        name: 'Nhóm quyền quản lý tài khoản Zalo',
    },
    {
        label: 'Xem danh sách bạn bè Zalo',
        value: 'GET::/api/otek-dashboard/zalo-account-service/get-list-zalo-account-friends',
        group: GROUP_PERMISSIONS.zalo_account,
        name: 'Nhóm quyền quản lý tài khoản Zalo',
    },
    {
        label: 'Xem mapping Zalo ↔ đối tác',
        value: 'GET::/api/otek-dashboard/zalo-account-service/get-list-zalo-account-companies',
        group: GROUP_PERMISSIONS.zalo_account,
        name: 'Nhóm quyền quản lý tài khoản Zalo',
    },
    {
        label: 'Gán Zalo cho đối tác (admin)',
        value: 'POST::/api/otek-dashboard/zalo-account-service/add-list-zalo-account-companies',
        group: GROUP_PERMISSIONS.zalo_account,
        name: 'Nhóm quyền quản lý tài khoản Zalo',
    },
    {
        label: 'Bỏ gán Zalo khỏi đối tác (admin)',
        value: 'DELETE::/api/otek-dashboard/zalo-account-service/delete-list-zalo-account-companies',
        group: GROUP_PERMISSIONS.zalo_account,
        name: 'Nhóm quyền quản lý tài khoản Zalo',
    },
    // Phase 2.1 — Zalo friend-invite
    {
        label: 'Gửi lời mời kết bạn Zalo',
        value: 'POST::/api/otek-dashboard/zalo-account-service/friend-invite',
        group: GROUP_PERMISSIONS.zalo_account,
        name: 'Nhóm quyền quản lý tài khoản Zalo',
    },
    {
        label: 'Xem trạng thái bật/tắt tự động kết bạn của đối tác',
        value: 'GET::/api/otek-dashboard/zalo-account-service/cp-config/*/status',
        group: GROUP_PERMISSIONS.zalo_account,
        name: 'Nhóm quyền quản lý tài khoản Zalo',
    },
    {
        label: 'Đối chiếu lời mời kết bạn với Zalo (admin)',
        value: 'POST::/api/otek-dashboard/zalo-account-service/friend-invite/cross-check',
        group: GROUP_PERMISSIONS.zalo_account,
        name: 'Nhóm quyền quản lý tài khoản Zalo',
    },
    {
        label: 'Xem lời mời đã gửi theo tài khoản Zalo',
        value: 'GET::/api/otek-dashboard/zalo-account-service/friend-invite/pending-by-account',
        group: GROUP_PERMISSIONS.zalo_account,
        name: 'Nhóm quyền quản lý tài khoản Zalo',
    },
    {
        label: 'Xem lịch sử lời mời kết bạn',
        value: 'GET::/api/otek-dashboard/zalo-account-service/friend-invite/list',
        group: GROUP_PERMISSIONS.zalo_account,
        name: 'Nhóm quyền quản lý tài khoản Zalo',
    },
    {
        label: 'Kiểm tra trạng thái kết bạn Zalo',
        value: 'GET::/api/otek-dashboard/zalo-account-service/friend-invite/check-status',
        group: GROUP_PERMISSIONS.zalo_account,
        name: 'Nhóm quyền quản lý tài khoản Zalo',
    },
    // Phase 2.1 — Zalo CP-config admin CRUD
    {
        label: 'Xem danh sách cấu hình Zalo theo đối tác (admin)',
        value: 'GET::/api/otek-dashboard/zalo-account-service/cp-config',
        group: GROUP_PERMISSIONS.zalo_account,
        name: 'Nhóm quyền quản lý tài khoản Zalo',
    },
    {
        label: 'Xem chi tiết cấu hình Zalo của đối tác (admin)',
        value: 'GET::/api/otek-dashboard/zalo-account-service/cp-config/*',
        group: GROUP_PERMISSIONS.zalo_account,
        name: 'Nhóm quyền quản lý tài khoản Zalo',
    },
    {
        label: 'Thêm cấu hình Zalo cho đối tác (admin)',
        value: 'POST::/api/otek-dashboard/zalo-account-service/cp-config',
        group: GROUP_PERMISSIONS.zalo_account,
        name: 'Nhóm quyền quản lý tài khoản Zalo',
    },
    {
        label: 'Cập nhật cấu hình Zalo của đối tác (admin)',
        value: 'PUT::/api/otek-dashboard/zalo-account-service/cp-config',
        group: GROUP_PERMISSIONS.zalo_account,
        name: 'Nhóm quyền quản lý tài khoản Zalo',
    },
    {
        label: 'Xóa cấu hình Zalo của đối tác (admin)',
        value: 'DELETE::/api/otek-dashboard/zalo-account-service/cp-config/*',
        group: GROUP_PERMISSIONS.zalo_account,
        name: 'Nhóm quyền quản lý tài khoản Zalo',
    },

    // Outlet CRM — Đại lý
    {
        label: 'Truy vấn danh sách đại lý',
        value: 'POST::/api/otek-dashboard/outlet/filter',
        group: GROUP_PERMISSIONS.outlet,
        name: 'Nhóm quyền quản lý đại lý',
    },
    {
        label: 'Xem chi tiết đại lý',
        value: 'GET::/api/otek-dashboard/outlet/*',
        group: GROUP_PERMISSIONS.outlet,
        name: 'Nhóm quyền quản lý đại lý',
    },
    {
        label: 'Thêm đại lý',
        value: 'POST::/api/otek-dashboard/outlet',
        group: GROUP_PERMISSIONS.outlet,
        name: 'Nhóm quyền quản lý đại lý',
    },
    {
        label: 'Cập nhật đại lý',
        value: 'PATCH::/api/otek-dashboard/outlet/*',
        group: GROUP_PERMISSIONS.outlet,
        name: 'Nhóm quyền quản lý đại lý',
    },
    {
        label: 'Xoá đại lý',
        value: 'DELETE::/api/otek-dashboard/outlet/*',
        group: GROUP_PERMISSIONS.outlet,
        name: 'Nhóm quyền quản lý đại lý',
    },

    // Outlet CRM — Kho gán đại lý
    {
        label: 'Truy vấn danh sách kho gán đại lý',
        value: 'POST::/api/otek-dashboard/outlet-inventory-link/filter',
        group: GROUP_PERMISSIONS.outlet_inventory_link,
        name: 'Nhóm quyền kho gán đại lý',
    },
    {
        label: 'Xem chi tiết bản ghi kho gán đại lý',
        value: 'GET::/api/otek-dashboard/outlet-inventory-link/*',
        group: GROUP_PERMISSIONS.outlet_inventory_link,
        name: 'Nhóm quyền kho gán đại lý',
    },
    {
        label: 'Thêm bản ghi kho gán đại lý (thủ công)',
        value: 'POST::/api/otek-dashboard/outlet-inventory-link',
        group: GROUP_PERMISSIONS.outlet_inventory_link,
        name: 'Nhóm quyền kho gán đại lý',
    },
    {
        label: 'Cập nhật lô SIM đại lý',
        value: 'PATCH::/api/otek-dashboard/outlet-inventory-link/*',
        group: GROUP_PERMISSIONS.outlet_inventory_link,
        name: 'Nhóm quyền kho gán đại lý',
    },
    {
        label: 'Xoá bản ghi kho gán đại lý',
        value: 'DELETE::/api/otek-dashboard/outlet-inventory-link/*',
        group: GROUP_PERMISSIONS.outlet_inventory_link,
        name: 'Nhóm quyền kho gán đại lý',
    },

    // Outlet CRM — Giao SIM cho đại lý (wrapper)
    {
        label: 'Tạo đơn giao SIM cho đại lý',
        value: 'POST::/api/otek-dashboard/outlet-order/create',
        group: GROUP_PERMISSIONS.outlet_order,
        name: 'Nhóm quyền giao SIM cho đại lý',
    },
    {
        label: 'Gán SIM đơn hàng cũ cho đại lý',
        value: 'POST::/api/otek-dashboard/outlet-order/link-existing',
        group: GROUP_PERMISSIONS.outlet_order,
        name: 'Nhóm quyền giao SIM cho đại lý',
    },

    // Outlet CRM — Tương tác (activity)
    {
        label: 'Truy vấn danh sách tương tác',
        value: 'POST::/api/otek-dashboard/outlet-activity/filter',
        group: GROUP_PERMISSIONS.outlet_activity,
        name: 'Nhóm quyền tương tác đại lý',
    },
    {
        label: 'Xem chi tiết tương tác',
        value: 'GET::/api/otek-dashboard/outlet-activity/*',
        group: GROUP_PERMISSIONS.outlet_activity,
        name: 'Nhóm quyền tương tác đại lý',
    },
    {
        label: 'Thêm tương tác',
        value: 'POST::/api/otek-dashboard/outlet-activity',
        group: GROUP_PERMISSIONS.outlet_activity,
        name: 'Nhóm quyền tương tác đại lý',
    },
    {
        label: 'Cập nhật tương tác',
        value: 'PATCH::/api/otek-dashboard/outlet-activity/*',
        group: GROUP_PERMISSIONS.outlet_activity,
        name: 'Nhóm quyền tương tác đại lý',
    },
    {
        label: 'Xoá tương tác',
        value: 'DELETE::/api/otek-dashboard/outlet-activity/*',
        group: GROUP_PERMISSIONS.outlet_activity,
        name: 'Nhóm quyền tương tác đại lý',
    },
    {
        label: 'Truy vấn lịch hẹn sắp tới',
        value: 'POST::/api/otek-dashboard/outlet-activity/upcoming',
        group: GROUP_PERMISSIONS.outlet_activity,
        name: 'Nhóm quyền tương tác đại lý',
    },

    // Outlet CRM — Thỏa thuận giá (pricing)
    {
        label: 'Truy vấn danh sách thỏa thuận giá',
        value: 'POST::/api/otek-dashboard/outlet-pricing/filter',
        group: GROUP_PERMISSIONS.outlet_pricing,
        name: 'Nhóm quyền thỏa thuận giá đại lý',
    },
    {
        label: 'Xem chi tiết thỏa thuận giá',
        value: 'GET::/api/otek-dashboard/outlet-pricing/*',
        group: GROUP_PERMISSIONS.outlet_pricing,
        name: 'Nhóm quyền thỏa thuận giá đại lý',
    },
    {
        label: 'Thêm thỏa thuận giá',
        value: 'POST::/api/otek-dashboard/outlet-pricing',
        group: GROUP_PERMISSIONS.outlet_pricing,
        name: 'Nhóm quyền thỏa thuận giá đại lý',
    },
    {
        label: 'Cập nhật thỏa thuận giá',
        value: 'PATCH::/api/otek-dashboard/outlet-pricing/*',
        group: GROUP_PERMISSIONS.outlet_pricing,
        name: 'Nhóm quyền thỏa thuận giá đại lý',
    },
    {
        label: 'Xoá thỏa thuận giá',
        value: 'DELETE::/api/otek-dashboard/outlet-pricing/*',
        group: GROUP_PERMISSIONS.outlet_pricing,
        name: 'Nhóm quyền thỏa thuận giá đại lý',
    },
    {
        label: 'Lấy thỏa thuận giá hiệu lực hiện tại',
        value: 'POST::/api/otek-dashboard/outlet-pricing/get-active',
        group: GROUP_PERMISSIONS.outlet_pricing,
        name: 'Nhóm quyền thỏa thuận giá đại lý',
    },
    {
        label: 'Xem tổng quan CRM đại lý',
        value: 'POST::/api/otek-dashboard/outlet-analytics/stats',
        group: GROUP_PERMISSIONS.outlet_analytics,
        name: 'Nhóm quyền báo cáo đại lý',
    },
    {
        label: 'Xem báo cáo khu vực',
        value: 'POST::/api/otek-dashboard/outlet-analytics/region-report',
        group: GROUP_PERMISSIONS.outlet_analytics,
        name: 'Nhóm quyền báo cáo đại lý',
    },
    {
        label: 'Xem hiệu quả sale',
        value: 'POST::/api/otek-dashboard/outlet-analytics/sale-efficiency',
        group: GROUP_PERMISSIONS.outlet_analytics,
        name: 'Nhóm quyền báo cáo đại lý',
    },
    {
        label: 'Xem cảnh báo tồn hạn',
        value: 'POST::/api/otek-dashboard/outlet-analytics/overdue',
        group: GROUP_PERMISSIONS.outlet_analytics,
        name: 'Nhóm quyền báo cáo đại lý',
    },
    {
        label: 'Lấy danh sách tỉnh/huyện đại lý',
        value: 'POST::/api/otek-dashboard/outlet-analytics/geo-options',
        group: GROUP_PERMISSIONS.outlet_analytics,
        name: 'Nhóm quyền báo cáo đại lý',
    },
    {
        label: 'Xem lịch sử đấu nối đại lý',
        value: 'POST::/api/otek-dashboard/outlet-analytics/activation-history',
        group: GROUP_PERMISSIONS.outlet_analytics,
        name: 'Nhóm quyền báo cáo đại lý',
    },
]
